import { http, HttpResponse } from "msw";

// Real proxy path forwards to the product backend; in the demo we either
// return a fixture or a demo-mode placeholder.
const RICKROLL_HLS = "https://www.youtube.com/watch?v=xvFZjo5PgG0";

export const proxyHandlers = [
  // MTX: stream listing — HLS points to a public no-op URL for demo.
  http.get("/api/v1/product/proxy/mtx/api/v1/proxy/streams", () => {
    return HttpResponse.json([
      {
        path: "/live/hls/fighter420",
        urls: {
          hls: RICKROLL_HLS,
          webrtc: "wss://demo.dev.pvarki.fi/live/webrtc/fighter420",
          rtsps: "rtsps://demo.dev.pvarki.fi:8322/live/hls/fighter420",
          rtmps: "rtmps://demo.dev.pvarki.fi:1936/live/hls/fighter420",
          srt: "srt://demo.dev.pvarki.fi:8890?streamid=read:live/hls/fighter420",
        },
      },
      {
        path: "/live/hls/drone-recon",
        urls: {
          hls: RICKROLL_HLS,
          webrtc: "wss://demo.dev.pvarki.fi/live/webrtc/drone-recon",
          rtsps: "rtsps://demo.dev.pvarki.fi:8322/live/hls/drone-recon",
          rtmps: "rtmps://demo.dev.pvarki.fi:1936/live/hls/drone-recon",
          srt: "srt://demo.dev.pvarki.fi:8890?streamid=read:live/hls/drone-recon",
        },
      },
    ]);
  }),

  http.get("/api/v1/product/proxy/mtx/api/v1/proxy/credentials", () => {
    return HttpResponse.json({
      username: "Fighter01",
      password: Math.random().toString(36).slice(-12),
    });
  }),

  http.get(
    "/api/v1/product/proxy/tak/api/v1/tak-missionpackages/ephemeral/atak.zip",
    () => {
      return HttpResponse.json({
        ephemeral_url: "https://demo.dev.pvarki.fi/demo-not-available",
      });
    },
  ),

  http.get("/api/v1/product/proxy/tak/*", () => {
    return HttpResponse.json({
      demo: true,
      message: "Downloads are not available in demo mode",
    });
  }),

  // Catch-all so any other product-specific proxy path returns a structured
  // "this is a demo" response rather than a 404 that confuses uiv2's error
  // handling. This intentionally lives AFTER the specific handlers.
  http.get("/api/v1/product/proxy/:product/*", () => {
    return HttpResponse.json({
      demo: true,
      message: "This endpoint is not available in demo mode",
    });
  }),
];
